import { render, staticRenderFns } from "./AssignedUsersList.vue?vue&type=template&id=65c9d6f4&scoped=true&"
import script from "./AssignedUsersList.vue?vue&type=script&lang=js&"
export * from "./AssignedUsersList.vue?vue&type=script&lang=js&"
import style0 from "./AssignedUsersList.vue?vue&type=style&index=0&id=65c9d6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9d6f4",
  null
  
)

export default component.exports